import { createApi } from '../createApi';
import * as dummy from '../dummy/partners';
import * as real from '../api/partners';

const api = createApi(dummy, real);

export const partnerService = {
  /* 서비스 (유저용) */
  apply: api.applyPartner,
  getMe: api.getPartnerMe,

  /* 관리자 */
  adminGetList: api.getAdminPartners,
  adminUpdateStatus: api.updateAdminPartnerStatus,
};
